import ColorRange from'../../../fc-core/src/color-utils/colorrange';function _createColorRangeManager(a){let b=a.getChildren('colorManager');return a.getFromEnv('dataSource').colorrange?b?(a.addToEnv('colorManager',b[0]),void b[0].configure()):void(b=new ColorRange,a.attachChild(b,'colorManager'),a.addToEnv('colorManager',b),b.configure()):(b&&(b[0].config.legendItemIds=[]),void a.deleteFromEnv('colorManager'))}export default function(a){_createColorRangeManager(a)}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-charts/src/factories/colorrange.js
// module id = null
// module chunks = 